export default __webpack_public_path__ + "static/media/stripe.3121d0e8.svg";